import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { BillsPage } from '../pages/BillsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/bills')({
  component: Bills,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Bills() {
  return (
    <MainLayout>
      <BillsPage />
    </MainLayout>
  )
}
